import { useContext, useEffect, useState } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

import AboutMenuProfileItem from "shared/components/navigation/profile-menu/AboutMenuProfileItem";
import Avatar from "@material-ui/core/Avatar";
import CleanUpSessionIcon from "shared/components/utils/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Loader from "shared/components/feedback/loading/Loader";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuProfileSignOutItem from "shared/components/navigation/profile-menu/MenuProfileSignOutItem";
import PropTypes from "prop-types";
import SessionContext from "app/contexts/SessionContext";
import Text from "shared/components/data-display/mui/Text";
import { clearToken } from "app/auth/authService";
import env from "react-dotenv";
import { useStylesForAvatar } from "shared/styles/makeStyles";
import { useUser } from "shared/services/api/useUser";
import {
    useStyles,
    TextWrapper,
    UserWrapper,
    UserWrapperCol1,
    UserWrapperCol2,
    AvatarWrapper,
    UserFullNameWrapper,
    UserTitleWrapper,
    UserOfficeWrapper,
    MainAvatarWrapper,
} from "./UserProfileMenu.styles";

const UserProfileMenu = (props) => {
    const session = useContext(SessionContext);
    const { instance } = useMsal();

    const createDynamicMenuAnchor = () => {
        let anchor = document.createElement("div");
        anchor.style.position = "absolute";
        anchor.style.top = "2rem";
        anchor.style.right = "5rem";
        anchor.style.height = "25px";
        document.body.appendChild(anchor);
        return anchor;
    };

    let anchorEl = createDynamicMenuAnchor();
    const [avatarURL, setAvatarURL] = useState(null);
    const isAuthenticated = useIsAuthenticated();
    const [open, setOpen] = useState(false);
    const { getUserDetail } = useUser();
    const [mainProfileAvatarClass, setMainProfileAvatarClass] = useState(null);
    const classes = useStyles();
    const avatarClass = useStylesForAvatar();

    useEffect(() => {
        const loadAvatar = async () => {

            setMainProfileAvatarClass(classes.avatarWrapperWithoutBorder);

            if (session) {
                const fetchedUser = await getUserDetail([{ name: "$userId", value: session.id }]);

                if (fetchedUser?.SmallPhotoUrl) {
                    setAvatarURL(`${env.BESTWORK_REACT_ASSET_DOMAIN}/${fetchedUser.SmallPhotoUrl}`);
                }
            }
        };

        if (isAuthenticated) {
            loadAvatar();
        }

    }, [isAuthenticated, classes.avatarWrapperWithoutBorder, getUserDetail, session]);

    const setAvatarBorder = (showBorder) => {
        if (showBorder) {
            setMainProfileAvatarClass(classes.avatarWrapperWithBorder);
        } else {
            setMainProfileAvatarClass(classes.avatarWrapperWithoutBorder);
        }
    };

    const handleClick = (_event) => {
        setOpen(!open);
        setAvatarBorder(!open);
    };

    const handleAboutClick = () => {
        props.onAboutItemClick();
        setOpen(false);
    };

    const handleClearCache = async () => {
        await clearToken();
        instance.logout();
    };


    if (isAuthenticated) {
        return session !== null && session !== undefined ? (
            <>
                <IconButton
                    onClick={(event) => handleClick(event)}
                    color="inherit"
                    className={classes.customStyles}
                >
                    <MainAvatarWrapper className={mainProfileAvatarClass}>
                        <Avatar src={avatarURL} className={avatarClass.root} />
                    </MainAvatarWrapper>
                </IconButton>
                <Menu
                    getContentAnchorEl={null}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    open={open}
                    onClose={(event) => handleClick(event)}
                    PaperProps={{
                        className: classes.menuPaper,
                        elevation: 0,
                    }}
                >
                        <UserWrapper>
                            <UserWrapperCol1>
                                <AvatarWrapper>
                                    <Avatar alt="" src={avatarURL} />
                                </AvatarWrapper>
                            </UserWrapperCol1>
                            <UserWrapperCol2>
                                <UserFullNameWrapper>
                                    {session.fullName}
                                </UserFullNameWrapper>
                                <UserTitleWrapper>
                                    {session.currentTitle}
                                </UserTitleWrapper>
                                <UserOfficeWrapper>
                                    {session.currentOffice}
                                </UserOfficeWrapper>
                            </UserWrapperCol2>
                        </UserWrapper>
                        <MenuItem onClick={handleClearCache}>
                            <CleanUpSessionIcon></CleanUpSessionIcon>
                            <TextWrapper>
                                <Text variant="medium">Clean up session</Text>
                            </TextWrapper>
                        </MenuItem>
                        <AboutMenuProfileItem onClick={handleAboutClick} />
                        <MenuProfileSignOutItem />
                </Menu>
            </>
        ) : (
            <Loader height="1.5rem" width="1.5rem" />
        );
    }
};

UserProfileMenu.propTypes = {
    onAboutItemClick: PropTypes.func,
};

export default UserProfileMenu;
